module.exports = __webpack_public_path__ + "static/img/wechatpaycode.531d36e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wechatpaycode.png
// module id = y7x3
// module chunks = 1